import type {OttopilotDataViewerController} from "~/components/ottopilotDataViewer/ottopilotDataViewerController";
import {TableErrorComponent} from "~/components/ottopilotDataViewer/tableErrorComponent";
import type {OttopilotView, ViewType} from "~/components/ottopilotDataViewer/view";
import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";

export function GraphView<
    T extends {
        id: Uuid;
    },
>({
    controller,
    view,
    className,
}: {
    controller: OttopilotDataViewerController<T>;
    view: OttopilotView<T> & {
        viewType: ViewType.graph;
    };
    className?: string;
}) {
    return <TableErrorComponent error="View not implemented" />;
}
